/*
 * Copyright (c) Siemens AG 2018 ALL RIGHTS RESERVED.
 *
 * Digital Lifecycle Service (DLS)
 */

import React from 'react';

// Stateless component
const NavigationBarElementComponent = (props) => {
  /**
   * Handler for selecting an accordion
   * Will call the passed method of the parent
   * @param e
   */
  // oldCase whether the usecase is new or not
  let oldCase = false;
  const onAccordionSelect = (e) => {
    if (
      props.usecaseName === 'Launch' ||
      props.usecaseName === 'Onboarding Dashboard' ||
      props.usecaseName === 'Data Ingest Monitoring' ||
      props.usecaseName === 'Security Alarm Overview V5'
    ) {
      props.toggle();
    }
    // Only trigger if the usecase is changed
    if (props.usecasePath !== props.clickedUsecase) {
      oldCase = false;
      props.onAccordionSelect(props.usecasePath);
    }
  };
  if (props.usecasePath === props.clickedUsecase) {
    oldCase = true;
  }
  let attachClass;
  if (props.sideBarOpen) {
    attachClass = 'dls-ap-accordion-element';
  } else {
    attachClass = 'dls-ap-sidebar close';
  }
  if (oldCase) {
    return (
      //return the div without onclick trigger
      <React.Fragment>
        <div
          className={`${attachClass} dls-ap-padding-10 ${
            props.isActive ? 'dls-ap-accordion-element-active' : ''
          }`}
        >
          {props.usecaseName}
        </div>
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <div
          className={`${attachClass} dls-ap-padding-10 ${
            props.isActive ? '{dls-ap-accordion-element-active}' : ''
          }`}
          onClick={onAccordionSelect}
        >
          {props.usecaseName}
        </div>
      </React.Fragment>
    );
  }
};

export default NavigationBarElementComponent;
